import m0 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/.temp/app-enhancers/0.js"
import m1 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/.temp/app-enhancers/1.js"
import m2 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/.temp/app-enhancers/data-block.js"
import m3 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/.temp/app-enhancers/global-components-1.js"
import m4 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/.temp/app-enhancers/2.js"

export default [
  m0,
  m1,
  m2,
  m3,
  m4
]
